import { useAuth } from "@clerk/clerk-react";

import { fnUseSupabaseToken } from "../auth/auth";
import { appJotaiStore, useAtomValue } from "../app-jotai";
import {
  bFileBrowserOpenAtom,
  excalidrawAPIAtom,
  fnTriggerCloudSave,
} from "../cloud/cloudState";

/**
 * Cloud toolbar — save + folder icons, shown only when signed in.
 * Rendered as a positioned overlay in the bottom-right area.
 */
export const CloudToolbar = () => {
  const { isSignedIn } = useAuth();
  const fnGetToken = fnUseSupabaseToken();
  const oExcalidrawAPI = useAtomValue(excalidrawAPIAtom);

  if (!isSignedIn || !oExcalidrawAPI) {
    return null;
  }

  return (
    <div
      className="simpledraw-cloud-toolbar"
      style={{
        position: "fixed",
        bottom: 12,
        right: 12,
        display: "flex",
        gap: 6,
        zIndex: 5,
      }}
    >
      <button
        title="Save to Cloud"
        onClick={() => fnTriggerCloudSave(oExcalidrawAPI, fnGetToken)}
        style={{
          background: "var(--island-bg-color, #fff)",
          border: "1px solid var(--default-border-color, #e0e0e0)",
          borderRadius: 8,
          padding: "6px 10px",
          cursor: "pointer",
          fontSize: 16,
        }}
      >
        ☁️
      </button>
      <button
        title="My Drawings"
        onClick={() => appJotaiStore.set(bFileBrowserOpenAtom, true)}
        style={{
          background: "var(--island-bg-color, #fff)",
          border: "1px solid var(--default-border-color, #e0e0e0)",
          borderRadius: 8,
          padding: "6px 10px",
          cursor: "pointer",
          fontSize: 16,
        }}
      >
        📁
      </button>
    </div>
  );
};
